import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { XAxis } from "../chart/XAxis";
import "./PhoneHeartRate.css";

function PhoneHRVMinimap({ 
  data, day, mode, selection,
  setSelection, previousSelection, children
}) {
  const width = 300;
  const height = 28;
  const [marginLeft, marginRight, marginTop, marginBottom] = [21, 15, 15, 0];
  const innerWidth = width - marginLeft - marginRight;
  const innerHeight = height - marginTop - marginBottom;

  var timeKey = mode === "live" ? "timepoint" : "time";

  var minDay;
  var maxDay;
  minDay = new Date(day)
  maxDay = new Date(day)
  maxDay.setDate(maxDay.getDate() + 1);
  data = data.filter(
    (x) => new Date(x[timeKey]) >= minDay && new Date(x[timeKey]) <= maxDay
  );

  const xScale = useMemo(() => {
    return d3
      .scaleTime()
      .domain([minDay, maxDay])
      .range([marginLeft, marginLeft + innerWidth])
      .nice();
  }, [innerWidth, marginLeft, maxDay, minDay]);

  const yScale = useMemo(() => {
    const min = d3.min(data, (d) => d.rmssd);
    const max = d3.max(data, (d) => d.rmssd);
    return d3
      .scaleLinear()
      .domain([min, max])
      .range([innerHeight + marginBottom, marginBottom])
      .nice();
  }, [data, innerHeight, marginBottom]);

  const color = data.map((x) => {
    if (x.stress_index === null || x.stress_index === undefined) {
      return "#939393";
    }

    if (x.color === "green") {
      return "#5AD876"; //green
    } else if (x.color === "yellow") {
      return "#E8D286"; //yellow
    } else if (x.color === "red") {
      return "#E88686"; //red
    } else {
      return "#9a9a9a";
    }
  });

  const brush = useMemo(() => {
    return d3.brushX().extent([
      [0 + marginLeft, 0],
      [innerWidth + marginLeft, innerHeight]
    ]).on("brush end", (event) => {
      if (event.selection) {
        const timeSelection = event.selection.map(xScale.invert);
        setSelection(timeSelection);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerHeight, innerWidth, marginLeft, setSelection, xScale.invert])

  useEffect(() => {
    if (previousSelection === selection || previousSelection === undefined) {
      d3.select(".brushHrv").call(brush).call(brush.move, selection.map(xScale));
    }
  }, [brush, previousSelection, selection, xScale])

  return (
    <>
      {data && (
        <>
          {children(selection)}
          <div className="heartRate_chart" style={{ paddingTop: 0 }}>
            <div className="heartRate_chart__Chart">
              <svg className="Sparkline hrv" viewBox={`0 0 ${width} ${height}`}>
                <g>
                  {data.map((d, i) => (<rect
                    x={xScale(new Date(d[timeKey]))}
                    value={d[timeKey]}
                    y={yScale(d.rmssd)}
                    height={innerHeight - yScale(d.rmssd) + marginBottom}
                    width={1.4}
                    key={`rect-${d[timeKey]}-${i}`}
                    className={d[timeKey]}
                    fill={color[i]}
                  ></rect>
                  ))}
                </g>
                <XAxis xScale={xScale} innerHeight={innerHeight + marginBottom} ticks={10}></XAxis>
                <g className="brushHrv"></g>
              </svg>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default observer(PhoneHRVMinimap);
